<template>
  <div v-if="isLegalLinkCheckoutEnabled" class="mt-12">
    <router-link to="/legal" class="text-button-guest-primary">Legal</router-link>
  </div>
</template>

<script setup lang="ts">
import { useFeatureFlags } from '@/common/composables/useFeatureFlags'

const { isLegalLinkCheckoutEnabled } = useFeatureFlags()
</script>
